export const faqContent = {
  title: 'The Mahj Market',
  subtitle: 'FAQ For Buyers and Sellers',
  metaTitle: 'FAQ | The Mahj Market',
  metaDescription:
    'Frequently asked questions for buyers and sellers about The Mahj Market, including orders, shipping, payments, fees, payouts, and seller expectations.',
  sections: [
    {
      heading: 'Buyer FAQs',
      questions: [
        {
          heading: 'What is The Mahj Market?',
          paragraphs: [
            'The Mahj Market is a curated destination for Mahjong sets and accessories, sourced from a community of independent sellers.',
          ],
        },
        {
          heading: 'Who fulfills my order?',
          paragraphs: [
            'Each purchase is fulfilled directly by the seller. The Mahj Market provides a seamless and secure platform for discovery and transaction.',
          ],
        },
        {
          heading: 'How does shipping work?',
          paragraphs: [
            'Shipping is integrated through Shippo for a transparent experience. Sellers provide package details in advance. At checkout, the available service is UPS Ground. A prepaid UPS Ground label is issued directly to the seller, with shipping insurance added when the merchandise value is over $100.',
          ],
        },
        {
          heading: 'Do you accept returns?',
          paragraphs: [
            'The Mahj Market does not offer standard returns. In the rare event an item arrives not as described, we will work closely with both parties to reach a fair resolution.',
          ],
        },
        {
          heading: 'How do you handle payment?',
          paragraphs: [
            'All transactions are securely handled through Stripe. Payment is held by Stripe until your package is received and approved by you. If the package is delivered and items are as promised, simply accept the transaction in your account and the seller will then be paid.',
            'Stripe charges a 3% transaction fee for use of your credit card, which will show at checkout. That fee is a pass-through fee and The Mahj Market does not benefit from that fee.',
          ],
        },
        {
          heading: 'Will I receive order updates?',
          paragraphs: [
            'You will receive timely email notifications at each stage - confirmation, shipment, and completion - so you remain informed throughout the experience. You will also receive a tracking number with the completed transaction, so you can follow your purchase.',
            'Please check your spam or junk folder if you are not receiving emails from The Mahj Market. You will receive emails, so if you do not see them, they are going somewhere.',
          ],
        },
      ],
    },
    {
      heading: 'Seller FAQs',
      questions: [
        {
          heading: 'What does The Mahj Market offer to a seller?',
          paragraphs: [
            'The Mahj Market offers a streamlined platform to present and sell your Mahjong items to a highly engaged audience. Listings are managed effortlessly through your personal profile/dashboard.',
            'All payments are held in escrow with Stripe until the items are received, and then Stripe releases your funds securely to the bank account on your setup.',
          ],
        },
        {
          heading: 'What is your fee structure?',
          paragraphs: [
            'We believe in simplicity and transparency.',
            'The Mahj Market charges a flat 8% commission on each completed sale.',
          ],
        },
        {
          heading: 'How does shipping work?',
          paragraphs: [
            'All shipping is facilitated through Shippo. This ensures a seamless payout for all sellers.',
            'You will simply enter the package dimensions and weight when creating your listing. A guide with box sizes and weights of standard items is given at the top of each listing, but please verify for each item you list.',
            'At the time of purchase:',
          ],
          listItems: [
            'UPS Ground is the only available shipping method.',
            'A prepaid label is generated.',
            'The label can then be downloaded and printed, attached to the package, and dropped at a UPS facility.',
          ],
        },
        {
          heading: 'How do I get paid?',
          paragraphs: [
            "Payments are securely processed via Stripe. The buyer's funds are held by Stripe until the package is received. Once received, the buyer can go onto the system and mark the package as accepted.",
            "If the buyer doesn't go back and accept, the funds are automatically released 10 days from the date you mailed the package. This allows enough time to ensure the item is received. Once the funds are released, your bank may require an additional 5-7 days to post to your account.",
          ],
        },
        {
          heading: 'Will I receive updates?',
          paragraphs: [
            'You will receive email notifications at each key moment - when your item is sold, paid for, shipped, and when your payout is issued. Remember, once payment is issued your bank may take an additional 7-10 days for the payment to post to your account.',
            'Please check your junk or spam folders. The email comes from The Mahj Market. Also check your listings periodically to make sure you did not sell something and miss the email notification.',
          ],
        },
        {
          heading: "What are The Mahj Market's standards and expectations?",
          paragraphs: [
            'Sellers are expected to present items with accuracy and integrity. To preserve the integrity of The Mahj Market, all items must be authentic and compliant with applicable intellectual property standards. We reserve the right to remove any listing suspected of infringing upon these standards.',
            'The Mahj Market is built on a foundation of trust, discretion, and quality - bringing together a community that values both the artistry of Mahjong and the integrity of the marketplace.',
          ],
        },
      ],
    },
  ],
};

export default faqContent;
